import React from 'react'
import { CARD_THIRD_COLUMN1 } from '../../data';
import { FAST_TRACK_DATA } from '../../data/fastTrack';
import classNames from 'classnames';
import styles from '../refresherCoursePage/refreshCoursePage.module.css';
import Button from '../button';
import { promo, heroImage } from '../../images';

const Scholarship = () => {

const handleRegisterClick = () => {
  window.open('https://tally.so/r/3ydVag', '_blank');
}

// Array of application steps
const applicationSteps = [
  "1. Fill the Application Form (basic info + short essay)",
  "2. Choose the scholarship tier you’re applying for",
  "3. Attend a brief interview (if shortlisted)",
  "4. Winners will be contacted via phone and email",
  "5. Application closes: 10th March 2025"
];

// Dummy data for "Who should Apply" section
const whoShouldApplyData = [
  {
    firstColumn: [
      {
        title: "Career Changers",
        text: "Women looking to transition into the tech industry from other professional backgrounds",
        icon: "🔄"
      },
      {
        title: "Recent Graduates",
        text: "Women who recently completed degrees and want to start their tech career journey",
        icon: "🎓"
      },
      {
        title: "Tech Enthusiasts",
        text: "Self-taught women with passion for technology seeking formal training and certification",
        icon: "💻"
      }
    ],
    secondColumn: [
      {
        title: "Returning Professionals",
        text: "Women returning to the workforce after a career break who want to enter the tech field",
        icon: "🔙"
      },
      {
        title: "Upskilling Professionals",
        text: "Women currently in tech roles looking to expand their skills and advance their careers",
        icon: "📈"
      },
      {
        title: "Entrepreneurs",
        text: "Women building tech startups who need technical knowledge to grow their businesses",
        icon: "🚀"
      }
    ]
  }
];

 return (
    <>
      <section className={styles["section_no_background"]}>
        <div className={styles["top_banner"]}>
          <div className={styles["banner_info"]}>
            <div className={styles["banner_text"]}>
              <div className='flex gap-2'>
                <div className={styles["tag"]}>Women in Tech</div>
            
              </div>

              <div className={`${styles["banner_title"]}`}>
                International Women’s Day Tech Scholarship
              </div>

              <div className={styles["banner_message"]}>
              At TheSkillGarage, we are committed to helping women break into tech. To celebrate International Women’s Day, we are offering over $50,000 worth of scholarships for our Business Analysis, Data Analysis, and Project Management programs!
              </div>
            </div>

            <div className={styles["banner_button"]}>
              <Button
                outline="black"
                variant="secondary"
                className={styles["enrol_now"]}
                onClick={handleRegisterClick}
              >
                Apply Now
              </Button>
            </div>
          </div>

          <div className={styles["banner_photo"]}>
            <img src={heroImage} alt="banner" />
          </div>
        </div>
        <div className={styles["first_course_inf"]}>
          <div className={styles["inf_point"]}>
            <div className={styles["point"]}>Application Closes</div>
            <div className={styles["info"]}>10th March, 2025</div>
          </div>
          <div className={styles["inf_point"]}>
            <div className={styles["point"]}>Platinum Scholarship</div>
            <div className={styles["info"]}>Fully funded </div>
            <div className='font-poppins font-normal text-[#333333] leading-[20px] text-[12px]'>2 Open slots</div>
          </div>
          <div className={styles["inf_point"]}>
            <div className={styles["point"]}>Gold Scholarship</div>
            <div className={styles["info"]}>75% Funded </div>
            <div className='font-poppins font-normal text-[#333333] leading-[20px] text-[12px]'>15 Open positions </div>
          </div>
          <div className={styles["inf_point"]}>
            <div className={styles["point"]}>Silver Scholarship</div>
            <div className={styles["info"]}>50% Funded </div>
            <div className='font-poppins font-normal text-[#333333] leading-[20px] text-[12px]'>15 open positions </div>
          </div>
        </div>
      </section>
      <section className={styles["section_first_background"]}>
          <p className='text-[#1E1B2E] font-poppins font-bold text-[28px] leading-[36px]'>Programs covered </p>
        <div className={styles["background_section_body"]}>
          <div className={styles["card_row"]}>
            {CARD_THIRD_COLUMN1.map(
              (item, index) =>
                item.firstColumn &&
                item.firstColumn.map((item, index) => (
                  <div className={styles["card_item"]} key={index}>
                    <div className={styles["icon_card"]}>
                      <div className={styles['icon-wrapper']}>
                            {typeof item.icon === 'string' ? (
                              <img
                                className={styles['img']}
                                src={item.icon}
                                alt="item icon"
                                loading="lazy"
                              />
                            ) : (
                              <item.icon className={styles['img']} />
                            )}
                      </div>

                      <div className={styles["card_title"]}>{item.title}</div>
                      <div className={styles["card_text"]}>{item.text}</div>
                    </div>
                  </div>
                ))
            )}
          </div>
        </div>
      </section>
      <section className='flex flex-col w-full items-center justify-center gap-0 mt-6 mb-3 p-5'>
        <p className='text-[#1E1B2E]  font-poppins font-bold text-[28px] mb-3 leading-[36px]'>How to Apply</p>
          {applicationSteps.map((step, index) => (
        <div className={styles['questions_block']} key={index}>
            <div className={styles['question_item']}>
              <div className={styles['question']}>
                {step}
              </div>
            </div>
        </div>
          ))}
            <div className={styles["banner_button"] + ' mt-7 mb-3'}>
              <Button
                outline="black"
                variant="secondary"
                className={styles["enrol_now"]}
                onClick={handleRegisterClick}
              >
                Apply Now
              </Button>
            </div>
      </section>

      {/* add new section here  */}
      <section className={styles["section_first_background2"]}>
        <p className='text-[#1E1B2E] mb-16 md:mb-6 font-poppins font-bold text-[28px] leading-[36px]'>Who should Apply</p>
        <div className={styles["background_section_body"]}>
          <div className={styles["card_row"]}>
            {whoShouldApplyData.map(
              (item, index) =>
                item.firstColumn &&
                item.firstColumn.map((item, index) => (
                  <div className={styles["card_item"]} key={index}>
                    <div className={styles["icon_card"]}>
                      <div className={styles['icon-wrapper']}>
                        <span className="text-3xl">{item.icon}</span>
                      </div>
                      <div className={styles["card_title"]}>{item.title}</div>
                      <div className={styles["card_text"]}>{item.text}</div>
                    </div>
                  </div>
                ))
            )}
          </div>

          <div className={styles["card_row"]}>
            {whoShouldApplyData.map(
              (item, index) =>
                item.secondColumn &&
                item.secondColumn.map((item, index) => (
                  <div className={styles["card_item"]} key={index}>
                    <div className={styles["icon_card"]}>
                      <div className={styles['icon-wrapper']}>
                        <span className="text-3xl">{item.icon}</span>
                      </div>
                      <div className={styles["card_title"]}>{item.title}</div>
                      <div className={styles["card_text"]}>{item.text}</div>
                    </div>
                  </div>
                ))
            )}
          </div>
          
          {/* <div className="text-center mt-8 px-4 max-w-4xl mx-auto">
            <div className={styles['questions_block']}>
            </div>
            <p className="text-[#1E1B2E] font-poppins text-lg">
              We want to support women who are most in need and most committed—this is why our scholarships will be awarded based on both financial need and merit.
            </p>

          </div> */}
        </div>
      </section>
    </>
  );
}

export default Scholarship